export const clamp = (value, min, max) => Math.max(min, Math.min(max, value))

import { createCanvasAdapter } from '../avatarEngine/canvasAdapter'

export const createLayerCanvas = (width, height) => {
  const adapter = createCanvasAdapter()
  const canvas = adapter.createDOMCanvas(
    Math.max(1, Math.round(width)),
    Math.max(1, Math.round(height))
  )
  return {
    canvas,
    ctx: adapter.getContext(canvas, '2d')
  }
}

export const toDataUrl = (canvas) => {
  if (!canvas) return null
  try {
    return canvas.toDataURL('image/png')
  } catch {
    return null
  }
}

export const drawPath = (
  ctx,
  landmarks,
  indices,
  width,
  height,
  { close = true, stroke = null, fill = null, lineWidth = 1.8 } = {}
) => {
  if (!ctx || !landmarks?.length || !indices?.length) return false
  const first = landmarks[indices[0]]
  if (!first) return false
  ctx.beginPath()
  ctx.moveTo(first.x * width, first.y * height)
  for (let i = 1; i < indices.length; i += 1) {
    const point = landmarks[indices[i]]
    if (!point) continue
    ctx.lineTo(point.x * width, point.y * height)
  }
  if (close) ctx.closePath()
  if (fill) {
    ctx.fillStyle = fill
    ctx.fill()
  }
  if (stroke) {
    ctx.strokeStyle = stroke
    ctx.lineWidth = lineWidth
    ctx.stroke()
  }
  return true
}

export const drawPointsPath = (
  ctx,
  points,
  { close = true, stroke = null, fill = null, lineWidth = 1.8 } = {}
) => {
  if (!ctx || !points?.length) return false
  const first = points[0]
  if (!first) return false
  ctx.beginPath()
  ctx.moveTo(first.x, first.y)
  for (let i = 1; i < points.length; i += 1) {
    const point = points[i]
    if (!point) continue
    ctx.lineTo(point.x, point.y)
  }
  if (close) ctx.closePath()
  if (fill) {
    ctx.fillStyle = fill
    ctx.fill()
  }
  if (stroke) {
    ctx.strokeStyle = stroke
    ctx.lineWidth = lineWidth
    ctx.stroke()
  }
  return true
}

export const drawCircle = (ctx, x, y, radius, fill) => {
  if (!ctx || !Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(radius)) return
  if (radius <= 0) return
  ctx.beginPath()
  ctx.arc(x, y, radius, 0, Math.PI * 2)
  ctx.fillStyle = fill
  ctx.fill()
}
